/**
 * Updates the URLSearchParams for a given filter group.
 * If the filter is already set to the given option, it removes it.
 * Otherwise, it sets the filter to the given option.
 */

/**
 * Sanitizes URL parameter values by removing problematic characters
 * that can break Typesense queries, specifically non-breaking spaces (=C2=A0)
 */
export function sanitizeUrlParam(value: string | null): string {
  if (!value) return '';

  // Remove URL-encoded non-breaking spaces (=C2=A0) and other problematic characters
  return value
    .replace(/=C2=A0/g, '') // Remove URL-encoded non-breaking spaces
    .replace(/\u00A0/g, ' ') // Replace actual non-breaking spaces with regular spaces
    .trim(); // Remove leading/trailing whitespace
}

/**
 * Safely gets and sanitizes a URL search parameter
 */
export function getSanitizedParam(searchParams: URLSearchParams, key: string): string {
  return sanitizeUrlParam(searchParams.get(key));
}

export function updateFilterSearchParams(
  searchParams: URLSearchParams,
  groupTitle: string,
  optionLabel: string,
): URLSearchParams {
  const newParams = new URLSearchParams(searchParams);
  if (groupTitle === 'Brand') {
    newParams.get('brand') === optionLabel
      ? newParams.delete('brand')
      : newParams.set('brand', optionLabel);
  } else if (groupTitle === 'Subtype') {
    newParams.get('subtype') === optionLabel
      ? newParams.delete('subtype')
      : newParams.set('subtype', optionLabel);
  } else if (groupTitle === 'Classification') {
    newParams.get('classification') === optionLabel
      ? newParams.delete('classification')
      : newParams.set('classification', optionLabel);
  } else if (groupTitle === 'Size') {
    newParams.get('size') === optionLabel
      ? newParams.delete('size')
      : newParams.set('size', optionLabel);
  } else if (groupTitle === 'Deal') {
    newParams.get('discount_applied') === optionLabel
      ? newParams.delete('discount_applied')
      : newParams.set('discount_applied', optionLabel);
  }
  return newParams;
}

/**
 * Clears all filters from the URLSearchParams.
 */
export function clearFilterSearchParams(): URLSearchParams {
  return new URLSearchParams();
}

/**
 * Updates the sort parameter in the URLSearchParams.
 */
export function updateSortSearchParams(
  searchParams: URLSearchParams,
  sort: string,
): URLSearchParams {
  const newParams = new URLSearchParams(searchParams);
  newParams.set('sort', sort);
  return newParams;
}

/**
 * Export your sort options as a constant for reuse.
 */
export const SORT_OPTIONS = [
  'Sort by Popular',
  'Price (Low - High)',
  'Price (High - Low)',
  'Name (A-Z)',
  'Name (Z-A)',
];
